import * as PIXI from "pixi.js";
import {t, TKeys} from "../translationService";
import {CANVAS, REEL, SLOT_BOARD} from "../constants/configs";
import {pixiComponents} from "../index";
import {getAmountWithCurrency, universalClick} from "../utilites";
import {spinStore, store} from "../store";
import {isMobile} from "pixi.js";
import {gsap} from "gsap";
import {buyFreeSpins, setBuyFreeBetBoardVisible} from "./index";
import {spinControlPanel} from "../slotBoard/spin";

const textStyle = new PIXI.TextStyle({
    fontFamily: 'BebasNeue',
    fontWeight: 500,
    fill: ['#ffffff', '#c0c0c0'],
    dropShadow: true,
    dropShadowColor: 'rgba(0,0,0,0.68)',
    dropShadowBlur: 2,
    dropShadowAngle: Math.PI / 4,
    dropShadowDistance: 2,
    fontSize: 80,
    wordWrapWidth: CANVAS.width * 1.8,
    align: 'center',
});

export const addQuestionModalBuyFreeSpins = () => {
    const container = new PIXI.Container();
    container.visible = false;
    container.eventMode = "static";

    const background = new PIXI.Graphics();
    background.beginFill("rgba(0,0,0,0.3)");
    background.drawRect(0, 0, 1500, 1500);
    background.endFill();
    background.eventMode = "static";
    universalClick(background, hideQuestionModalBuyFreeSpins);

    const backgroundImage = new PIXI.Sprite(PIXI.Texture.from("./assets/buyFreeSpinsModalBg.webp"));
    backgroundImage.anchor.set(0.5);
    backgroundImage.position.set(CANVAS.width/2, CANVAS.height/2.4);
    backgroundImage.scale.set(0.85, 0.85);

    const questionText = new PIXI.Text(`${t(TKeys.BUY_FREE_SPINS)} \n ${getAmountWithCurrency(spinStore.spinAmount*100, store.currency)}`, textStyle);
    questionText.updateFreeSpinPrice = (freeSpinPrice) => questionText.text = `${t(TKeys.BUY_FREE_SPINS)} \n ${getAmountWithCurrency(freeSpinPrice, store.currency)}`;
    questionText.anchor.set(0.5);
    questionText.position.set(CANVAS.width / 2, CANVAS.height / 3);

    const cancelBtn = new PIXI.Sprite(PIXI.Texture.from("./assets/cancelIcon.webp"));
    cancelBtn.scale.set(1.1);
    cancelBtn.anchor.set(isMobile.phone ? 1 : 0.5, 0.5);
    cancelBtn.position.set(CANVAS.width * 4 / 10, CANVAS.height / 1.9);
    cancelBtn.eventMode = "static";
    cancelBtn.cursor = 'pointer';
    universalClick(cancelBtn, hideQuestionModalBuyFreeSpins);

    const acceptBtn = new PIXI.Sprite(PIXI.Texture.from("./assets/acceptIcon.webp"));
    acceptBtn.scale.set(1.1);
    acceptBtn.anchor.set(isMobile.phone ? 0 : 0.5, 0.5);
    acceptBtn.position.set(CANVAS.width * 6 / 10, CANVAS.height / 1.9);
    acceptBtn.eventMode = "static";
    acceptBtn.cursor = 'pointer';
    universalClick(acceptBtn, () => {
        buyFreeSpins();
        hideQuestionModalBuyFreeSpins();
    });

    container.addChild(background, backgroundImage, questionText, cancelBtn, acceptBtn)
    pixiComponents.app.stage.addChild(container);
    pixiComponents.questionModalBuyFreeSpins = {container, background, backgroundImage, questionText, cancelBtn, acceptBtn};

    const colorMatrix = new PIXI.ColorMatrixFilter();
    backgroundImage.filters = [colorMatrix];
    const winPulsation = {alpha: 0.9};

    gsap.to(winPulsation, {
        alpha: 1.05,
        duration: 0.6,
        repeat: -1,
        yoyo: true,
        onUpdate: function () {
            colorMatrix.brightness(winPulsation.alpha);
        }
    });
}

export const hideQuestionModalBuyFreeSpins = () => {
    const modal = pixiComponents.questionModalBuyFreeSpins.container;

    gsap.to(modal, {
        alpha: 0,
        duration: 0.3,
        onComplete: () => {
            modal.visible = false
        },
    });
}

export const showQuestionModalBuyFreeSpins = () => {
    if(spinControlPanel.isSpinning){
        return;
    }
    const modal = pixiComponents.questionModalBuyFreeSpins.container;
    modal.visible = true;
    modal.alpha = 0.3;

    gsap.to(modal, {
        alpha: 1,
        duration: 0.3,
    });
}

export const updateQuestionItemsPositions = () => {
    const {questionText, cancelBtn, acceptBtn, backgroundImage} = pixiComponents.questionModalBuyFreeSpins;
    questionText.position.set(pixiComponents.app.screen.width / 2, pixiComponents.app.screen.height / 3);

    if(isMobile.phone){
        if(pixiComponents.app.screen.width>pixiComponents.app.screen.height){
            backgroundImage.rotation = 0;
            backgroundImage.scale.set(0.8, 0.8);
            backgroundImage.position.set(pixiComponents.app.screen.width / 2, pixiComponents.app.screen.height / 2.3);
            cancelBtn.position.set(pixiComponents.app.screen.width * 4 / 10, pixiComponents.app.screen.height / 1.7);
            acceptBtn.position.set(pixiComponents.app.screen.width * 6 / 10, pixiComponents.app.screen.height / 1.7);
        }else{
            backgroundImage.position.set(pixiComponents.app.screen.width / 2, pixiComponents.app.screen.height / 2.6);
            backgroundImage.rotation = 0;
            backgroundImage.scale.set(0.65, 0.9);
            cancelBtn.position.set(pixiComponents.app.screen.width * 4 / 10, pixiComponents.app.screen.height / 1.9);
            acceptBtn.position.set(pixiComponents.app.screen.width * 6 / 10, pixiComponents.app.screen.height / 1.9);
        }
    }
}
